const AppDefaultValuesEnum = {
  LANGUAGE_ID: 1,
  LANGUAGE: 'en',
  PARTNER_ID: 4,
  GAME_ID: 141414,
  CURRENCY: 'USD',
  MODE: 'fun',
  APPLICATION_ID: 6,
};

Object.freeze(AppDefaultValuesEnum);

const AppConstantsEnum = {
  TOKEN: 'token',
  GAME_ID: 'gameid',
  EXIT_URL: 'exiturl',
  ACCESS: 'access',
  PARTNER_ID: 'partnerid',
  LANGUAGE: 'culture',
  LANGUAGE_1: 'language', // if partner don't have LANGUAGE key
  CURRENCY: 'currency',
  USERID: 'userid',
  MODE: 'mode',
};

Object.freeze(AppConstantsEnum);

export { AppDefaultValuesEnum, AppConstantsEnum };
